// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Middleware, Dispatch, AnyAction, MiddlewareAPI } from "redux";
import { constants } from "../../common/constants";
import localforage from "localforage";

export interface ILocalStorageMiddlewareOptions {
    paths: string[];
}

export function createLocalStorage(config: ILocalStorageMiddlewareOptions): Middleware {
    localforage.config({
        driver: localforage.INDEXEDDB, // Set the storage driver, e.g., localStorage, indexedDB, etc.
        name: "hatchetai", // Set a name for your database. It will be used as a namespace in the storage.
        version: 1, // Set the version of your database. You can use it to perform migrations in the future.
        storeName: "hatchetai", // Set the name of the storage store. It will be used as a key prefix for your data.
        description: "My App Local Storage", // Provide a description for your storage.
    });

    return (store: MiddlewareAPI<Dispatch<AnyAction>>) => (next: Dispatch<AnyAction>) => (action: any) => {
        const result = next(action);
        const state = store.getState();

        config.paths.forEach((path) => {
            if (state[path]) {
                const json = JSON.stringify(state[path]);
                setStorageItem(path, json);
            }
        });

        return result;
    };
}

export function mergeInitialState(state: any, paths: string[]) {
    const initialState = { ...state };
    for (let index = 0; index < paths.length; index++) {
        const path = paths[index];

        getStorageItem(path).then((json) => {
            if (json) {
                initialState[path] = JSON.parse(json as string);
            }
        });
    }

    return initialState;
}

export function setStorageItem(key: string, value: string) {
    return new Promise(resolve => {
        localforage.setItem(`${constants.version}_${key}`, value).then(() => {
            resolve(null);
        });
    })
    //return localforage.setItem(`${constants.version}_${key}`, value);
}

export function getStorageItem(key: string) {
    return new Promise(resolve => {
        localforage.getItem(`${constants.version}_${key}`).then(value => {
            resolve(value);
        });
    })
    //return localforage.getItem(`${constants.version}_${key}`);
}

export function removeStorageItem(key: string) {
    return new Promise(resolve => {
        localforage.removeItem(`${constants.version}_${key}`).then(() => {
            resolve(null);
        });
    });
    //return localforage.removeItem(`${constants.version}_${key}`);
}
